"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTime = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DateTime = function DateTime(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    i18n = _useTranslation.i18n;
  var date = new Date(props.millis).toLocaleDateString(i18n.language, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, date);
};
exports.DateTime = DateTime;